import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { useUserStore } from "@/common/store";
import { isLiteOnlyLocation, isPageAllowed } from "@/common/utils/geoRules";
import { onOpenLiteOnlyVerificationPopup } from "@/components/popup-dispatcher/PopupDispatcher";

export const useLiteOnlyVerificationPopup = () => {
  const { pathname } = useLocation();

  const geoLocation = useGeolocationStore((state) => state.location);
  const currentUser = useUserStore((state) => state.currentUser);

  useEffect(() => {
    if (!isLiteOnlyLocation(geoLocation)) {
      return;
    }

    if (isPageAllowed(pathname, geoLocation)) {
      return;
    }

    if (!currentUser?.username || currentUser.verified) {
      return;
    }

    onOpenLiteOnlyVerificationPopup();
  }, [pathname, geoLocation, currentUser]);
};
